import type { Geometry } from '@babylonjs/core/Meshes/geometry';
import type { Scene } from '@babylonjs/core/scene';
import { ResourceContext } from '@seddi/core';
import type { IMesh } from '@seddi/mesh';
import { geometryCreate } from '@seddi/ui-babylon-core';
import { MeshAdapter } from './meshAdapter';

/**
 * Loads the mesh.
 * @param mesh - Fabric to load.
 * @param scene - Graphics context.
 */
export async function loadMesh(mesh: IMesh, scene: Scene): Promise<Geometry> {
  const vmesh = MeshAdapter.adapt(mesh);
  return Promise.resolve(geometryCreate(vmesh.id, scene, vmesh.geometry));
}

/**
 * Class for managing the loading and storage of buttons.
 */
export class MeshesContext extends ResourceContext<Geometry> {
  /** Fx scene. */
  private readonly scene: Scene;

  /**
   * Creates a new mesh resources context.
   * @param scene - the Babylon scene.
   */
  constructor(scene: Scene) {
    super();
    this.scene = scene;
  }

  /**
   * Loads the mesh.
   * If the mesh is already loaded, returns a resolved promise.
   * If the mesh is currently being loaded, returns a promise that will be resolved when the mesh finishes loading.
   * @param mesh - Mesh to load.
   */
  public async loadEx(mesh: IMesh): Promise<void> {
    const resourceId = mesh.id;
    return super.load(resourceId, () => loadMesh(mesh, this.scene));
  }
}
